import type { Notification, UnreadCountResponse } from '@swiss-magic/shared-types';
import { currentSurface } from '../appSurface';
import { get, post } from './core';

// Surface-aware endpoint base. Player surface lives under /player/...;
// director surface uses the unprefixed default. `currentSurface` reads
// the hostname (production) with a URL-path fallback (single-host local
// dev), so the bell on `/player/dashboard` queries the player feed even
// when the colocated build can't tell surfaces apart by hostname alone.
function basePath(): string {
  return currentSurface() === 'player' ? '/player/notifications' : '/notifications';
}

export function listNotifications(): Promise<Notification[]> {
  return get<Notification[]>(basePath());
}

export function getUnreadCount(): Promise<UnreadCountResponse> {
  return get<UnreadCountResponse>(`${basePath()}/unread-count`);
}

export function markNotificationRead(id: string): Promise<void> {
  return post<void>(`${basePath()}/${id}/read`);
}

export function markAllNotificationsRead(): Promise<void> {
  return post<void>(`${basePath()}/read-all`);
}
